
import "babel-polyfill"

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/index.css'
import './assets/icon/iconfont.css'
import 'babel-polyfill';
import BaiduMap from 'vue-baidu-map'
import axios from 'axios';
Vue.prototype.axios = axios;

Vue.use(BaiduMap, {
  ak: 'QrfpRSO6S2vhDh2L7T9pgzNFTp5iiXxG'
});

import http from '@/utils/request'
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import Cookies from 'js-cookie'

// 挂载全局
Vue.prototype.$http = http

//引入swiper实现轮播图
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';


// window.SITE_CONFIG['apiURL'] = 'http://114.116.197.206:8090';

// 进度条配置项这样写
NProgress.configure({
  showSpinner: false
});


Vue.config.productionTip = false;
Vue.use(ElementUI, {
  size: 'small'
});


//使用钩子函数对路由进行权限跳转
// router.beforeEach((to, from, next) => {
//   document.title = `${to.meta.title}`;
//   const role = localStorage.getItem('loginUserinfo');
//   if (!role && to.path !== '/login') {
//     next('/login');
//   } else if (to.meta.permission) {
//
//     // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
//     role === 'admin' ? next() : next('/403');
//   } else {
//     // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
//     if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
//       Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
//         confirmButtonText: '确定'
//       });
//     } else {
//       next();
//     }
//   }
// });
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});
// 路由跳转后钩子函数中 - 执行进度条加载结束
router.afterEach(() => {
  NProgress.done();
});
new Vue({
  router,

  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js